// core version + navigation, pagination modules:
import Swiper, { Pagination } from "swiper";

// configure Swiper to use modules
Swiper.use([Pagination]);

(function () {
  const byImageslider = document.querySelectorAll(".mb-imageslider");
  let imageSwiper = [];

  for (let i = 0; i < byImageslider.length; i++) {
    imageSwiper[i] = new Swiper(byImageslider[i], {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 80,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
})();
